goog.module('yext.soy');
goog.module.declareLegacyNamespace();

const SanitizedHtml = goog.requireType('goog.soy.data.SanitizedHtml');

/**
 * Render a client-side template with the given data object, and inject messages
 * into it using a map of selector to yext.msg.
 * @param {function(ARG_TYPES, ?Object<string,*>=): !SanitizedHtml} tmpl The Soy template to render.
 * @param {ARG_TYPES=} opt_data The data for the template.
 * @param {!Object<string,string>=} opt_msgmap messages to inject into the resulting html
 * @return {!jQuery}
 * @template ARG_TYPES
 */
function render(tmpl, opt_data, opt_msgmap) {
  opt_data = opt_data || {};
  opt_msgmap = opt_msgmap || {};
  var $html = $(tmpl(opt_data).getContent());
  for (var sel in opt_msgmap) {
    $html.find(sel).text(opt_msgmap[sel]);
  }
  return $html;
}
goog.exportSymbol('render', render);

exports = {
  render,
};
